// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u4-0";
export var checkoutRateBadgeLink = "_u4-1";